/**
 * ANCHOR GLASSES STRAPS - SHOPIFY THEME JS
 * Version: 3.0.0 - Complete rebuild from localhost
 * Uses Shopify AJAX Cart API for all cart operations
 */
(function() {
  'use strict';

  // ===== SHOPIFY CART STATE =====
  var cartState = { items: [], item_count: 0, total_price: 0 };

  // ===== DOM ELEMENTS =====
  var navbar = document.getElementById('navbar');
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var mobileOverlay = document.getElementById('mobileOverlay');
  var cartBtn = document.getElementById('cartBtn');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartOverlay = document.getElementById('cartOverlay');
  var cartClose = document.getElementById('cartClose');
  var cartItemsEl = document.getElementById('cartItems');
  var cartFooter = document.getElementById('cartFooter');
  var cartCount = document.getElementById('cartCount');
  var cartItemCount = document.getElementById('cartItemCount');
  var cartTotal = document.getElementById('cartTotal');
  var backToTop = document.getElementById('backToTop');
  var newsletterForm = document.getElementById('newsletterForm');

  // ===== HERO PARTICLES =====
  (function createParticles() {
    var container = document.getElementById('heroParticles');
    if (!container) return;
    for (var i = 0; i < 30; i++) {
      var dot = document.createElement('div');
      dot.className = 'dot';
      var size = Math.random() * 4 + 2;
      dot.style.width = size + 'px';
      dot.style.height = size + 'px';
      dot.style.left = Math.random() * 100 + '%';
      dot.style.top = Math.random() * 100 + '%';
      dot.style.animationDuration = (Math.random() * 10 + 8) + 's';
      dot.style.animationDelay = (Math.random() * 10) + 's';
      container.appendChild(dot);
    }
  })();

  // ===== NAVBAR SCROLL =====
  var announcementBar = document.querySelector('.announcement-bar');
  var announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
  window.addEventListener('scroll', function() {
    if (navbar) {
      if (window.scrollY > announcementHeight) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    }
    if (backToTop) {
      if (window.scrollY > 600) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    }
  });

  // ===== MOBILE MENU =====
  if (hamburger && mobileMenu && mobileOverlay) {
    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('active');
      hamburger.setAttribute('aria-expanded', hamburger.classList.contains('active'));
      mobileMenu.classList.toggle('open');
      mobileOverlay.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    mobileOverlay.addEventListener('click', closeMobile);
    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeMobile);
    });
  }
  function closeMobile() {
    if (hamburger) hamburger.classList.remove('active');
    if (mobileMenu) mobileMenu.classList.remove('open');
    if (mobileOverlay) mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ===== CART DRAWER =====
  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ===== SHOPIFY AJAX CART API =====
  // Expose globally so product templates can call it
  window._anchorFetchCart = function() { return fetchCart().then(function() { openCart(); bumpCartCount(); }); };
  window._anchorAddToCart = function(variantId, qty) { return addToCart(variantId, qty || 1); };

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        cartState = cart;
        renderCart(cart);
        return cart;
      });
  }

  function addToCart(variantId, qty) {
    variantId = parseInt(variantId);
    qty = parseInt(qty) || 1;
    if (!variantId || isNaN(variantId)) {
      return Promise.reject('Invalid variant ID');
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
      return r.json();
    })
    .then(function(data) {
      // TikTok Pixel - AddToCart event
      if (window.ttq) {
        ttq.track('AddToCart', {
          content_id: variantId.toString(),
          content_type: 'product',
          quantity: qty,
          value: data.final_price ? data.final_price / 100 : 0,
          currency: 'USD'
        });
      }
      // Meta Pixel - AddToCart event
      if (window.fbq) {
        fbq('track', 'AddToCart', {
          content_ids: [variantId.toString()],
          content_type: 'product',
          value: data.final_price ? data.final_price / 100 : 0,
          currency: 'USD'
        });
      }
      return fetchCart();
    })
    .then(function() {
      openCart();
      bumpCartCount();
    });
  }

  function changeCartItem(lineKey, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return fetchCart();
    });
  }

  function bumpCartCount() {
    if (cartCount) {
      cartCount.classList.remove('bump');
      void cartCount.offsetWidth;
      cartCount.classList.add('bump');
    }
  }

  // UX TEST 2026-10-09: drawer rendering rebuilt. Shipping + gift wording comes from
  // window.AnchorStore (snippets/store-config.liquid, the single source). Prices and
  // discounts shown are Shopify's own numbers from /cart.js (automatic discounts such as
  // "Bundle Save" and "Add-On Cloths" are already in final_line_price / cart_level_discount_applications),
  // replacing the old client-side 10/15/20% and 50% estimates.
  function escHtml(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function renderCart(cart) {
    var totalItems = cart.item_count;
    var S = window.AnchorStore;
    if (cartCount) cartCount.textContent = totalItems;
    if (cartItemCount) cartItemCount.textContent = totalItems;
    if (cartTotal) cartTotal.textContent = fmt(cart.total_price);
    var shippingMsg = document.getElementById('cartShippingMsg');
    var bar = document.getElementById('cartShipBar');
    var discRow = document.getElementById('cartDiscountRow');

    if (cart.items.length === 0) {
      if (cartItemsEl) cartItemsEl.innerHTML = '<div class="cart-empty"><p style="font-size:1.05rem;color:#14243a;font-weight:600;">Your cart is empty</p><p style="margin:6px 0 18px;">Not sure where to start?</p><a class="ux-btn ux-btn--primary ux-btn--sm" href="/collections/all">Shop best sellers</a> <a class="ux-btn ux-btn--light ux-btn--sm" href="' + (window.AnchorFitUrl || '/pages/our-story?view=find-my-fit') + '">Find my fit</a></div>';
      if (cartFooter) cartFooter.style.display = 'none';
      var upsellEl = document.getElementById('cartUpsell');
      if (upsellEl) upsellEl.style.display = 'none';
      if (shippingMsg) shippingMsg.textContent = '';
      renderGiftBoxes(cart);
      return;
    }
    if (cartFooter) cartFooter.style.display = 'block';
    if (S) {
      if (shippingMsg) { shippingMsg.textContent = S.cartShip(cart); shippingMsg.className = 'ux-perk' + (cart.total_price >= S.shipThreshold ? ' ux-perk--good' : ''); }
      if (bar) { var pct = S.shipThreshold > 0 ? Math.min(100, Math.round(cart.total_price / S.shipThreshold * 100)) : 100; bar.style.width = pct + '%'; }
    }
    if (discRow) {
      var apps = cart.cart_level_discount_applications || [];
      if (cart.total_discount > 0) {
        var titles = apps.map(function(a) { return a.title; });
        cart.items.forEach(function(it) { (it.discounts || []).forEach(function(d) { if (d.amount > 0 && titles.indexOf(d.title) < 0) titles.push(d.title); }); });
        var label = titles.length ? titles.map(escHtml).join(', ') : 'Discounts';
        discRow.innerHTML = '<span>' + label + '</span><span>-' + fmt(cart.total_discount) + '</span>';
        discRow.style.display = 'flex';
      } else { discRow.style.display = 'none'; }
    }
    var html = '';
    cart.items.forEach(function(item) {
      var imgSrc = item.image ? (item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') : '';
      var priceHtml = (item.final_line_price < item.original_line_price ? '<s>' + fmt(item.original_line_price) + '</s>' : '') + fmt(item.final_line_price);
      html += '<div class="cart-item">' +
        '<a class="cart-item-img" href="' + item.url + '">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + escHtml(item.product_title) + '">' : '') + '</a>' +
        '<div class="cart-item-details">' +
          '<div class="cart-item-name">' + escHtml(item.product_title) + '</div>' +
          (item.variant_title ? '<div class="cart-item-variant">' + escHtml(String(item.variant_title).replace(/\bClear\b/g, 'Frosted White')) + '</div>' : '') +
          (giftLineFree(item) ? '<div class="ux-gift-tag">Free gift</div>' : '') +
          '<div class="cart-item-price">' + priceHtml + '</div>' +
          '<div class="cart-item-qty">' +
            '<button type="button" aria-label="Decrease quantity" onclick="window._cartQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" aria-label="Increase quantity" onclick="window._cartQty(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-item-remove" onclick="window._cartQty(\'' + item.key + '\',0)">Remove</button>' +
      '</div>';
    });
    html += '<div class="ux-gift-slot" data-gift-box></div>';
    if (cartItemsEl) cartItemsEl.innerHTML = html;
    renderGiftBoxes(cart);
    renderUpsell(cart);
    document.dispatchEvent(new CustomEvent('anchor:cart', { detail: cart }));
  }


  // ===== FREE GIFT BOX (gift picker 2026-10-10) =====
  // Shopify automatic discount "Spend $14 Get a Free Gift" (Buy X Get Y, max 1 per order) makes ONE lens cloth
  // or ONE Floating Keychain XL $0 when the other items reach the threshold, but only if the customer adds it.
  // This box (cart drawer + cart page, every [data-gift-box]) reads the REAL state from /cart.js:
  //   free  = a gift-product line has a "free gift" discount allocation > 0 (final price 0)
  //   under = items other than one gift unit are below the threshold
  //   pick  = threshold reached, no free gift yet
  //   lost  = a gift added from this box (line property _free_gift) is no longer discounted
  // Wording + gift products come from window.AnchorStore.gift (snippets/store-config.liquid). U.S. only.
  var giftChangeOpen = false;
  function giftCfg() { var S = window.AnchorStore; return (S && S.gift && S.giftEnabled && S.isUS && S.gift.products && S.gift.products.length) ? S.gift : null; }
  function giftProduct(handle) { var G = giftCfg(); if (!G) return null; for (var i = 0; i < G.products.length; i++) if (G.products[i].handle === handle) return G.products[i]; return null; }
  function giftLineFree(item) {
    var G = giftCfg(); if (!G || !giftProduct(item.handle)) return false;
    return (item.line_level_discount_allocations || []).some(function(a) { return a.amount > 0 && G.discount.test((a.discount_application && a.discount_application.title) || ''); }) ||
      (item.discounts || []).some(function(d) { return d.amount > 0 && G.discount.test(d.title || ''); });
  }
  function giftState(cart) {
    var G = giftCfg();
    if (!G || !cart || !cart.item_count) return null;
    var free = null, tagged = null, any = null, total = 0;
    cart.items.forEach(function(it, i) {
      total += it.original_line_price;
      if (!giftProduct(it.handle)) return;
      var ref = { item: it, line: i + 1, product: giftProduct(it.handle) };
      if (!free && giftLineFree(it)) free = ref;
      if (!tagged && it.properties && it.properties._free_gift) tagged = ref;
      if (!any) any = ref;
    });
    var unit = free || tagged || any;
    var nonGift = total - (unit ? unit.item.original_price : 0);
    var need = G.threshold - nonGift;
    var state = free ? 'free' : tagged ? 'lost' : need > 0 ? 'under' : 'pick';
    return { state: state, need: need, gift: free || tagged, other: any, G: G };
  }
  function giftName(ref) {
    var t = ref.product.name;
    if (ref.product.variants.length > 1 && ref.item.variant_title) t += ' (' + ref.item.variant_title + ')';
    return t;
  }
  var GIFT_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  function giftOptions(st, mode) {
    var G = st.G, cur = st.gift ? st.gift.item.variant_id : 0;
    return '<div class="ux-gift__opts">' + G.products.map(function(p) {
      var avail = p.variants.filter(function(v) { return v.available; });
      if (!avail.length) return '';
      var first = avail[0];
      for (var i = 0; i < avail.length; i++) if (avail[i].id === cur) first = avail[i];
      var sel = avail.length > 1 ? '<select class="ux-gift__sel" data-gift-variant aria-label="Choose a color for the ' + escHtml(p.name) + '">' + avail.map(function(v) {
        return '<option value="' + v.id + '" data-img="' + escHtml(v.img) + '"' + (v.id === first.id ? ' selected' : '') + '>' + escHtml(v.title) + '</option>';
      }).join('') + '</select>' : '';
      var isCur = mode === 'swap' && st.gift && st.gift.product.handle === p.handle && avail.length < 2;
      var label = mode === 'swap' ? (isCur ? 'Your gift' : 'Choose this') : 'Add free';
      return '<div class="ux-gift__opt" data-gift-card>' +
        '<img src="' + escHtml(first.img || p.img) + '" alt="' + escHtml(p.name) + '" loading="lazy" width="120" height="120">' +
        '<div class="ux-gift__optname">' + escHtml(p.name) + '</div>' +
        '<div class="ux-gift__optprice"><s>' + fmt(p.price) + '</s> Free</div>' + sel +
        '<button type="button" class="ux-gift__btn" data-gift-' + (mode === 'swap' ? 'swap' : 'add') + '="' + first.id + '"' + (isCur ? ' disabled' : '') + '>' + label + '</button>' +
      '</div>';
    }).join('') + '</div>';
  }
  function giftBoxHtml(st) {
    var G = st.G, note = G.returnNote ? '<p class="ux-gift__note">' + escHtml(G.returnNote) + '</p>' : '';
    var head = function(msg, extra) { return '<div class="ux-gift__head">' + GIFT_ICON + '<span>' + msg + '</span>' + (extra || '') + '</div>'; };
    if (st.state === 'under') {
      var msg = st.other ? G.underHave(fmt(st.need), st.other.product.name.toLowerCase()) : G.under(fmt(st.need));
      return '<div class="ux-gift ux-gift--under" role="status">' + head(escHtml(msg)) +
        '<div class="ux-gift__thumbs">' + G.products.map(function(p) { return '<span><img src="' + escHtml(p.img) + '" alt="" loading="lazy" width="40" height="40">' + escHtml(p.name) + '</span>'; }).join('') + '</div></div>';
    }
    if (st.state === 'pick') {
      return '<div class="ux-gift ux-gift--pick" role="region" aria-label="Choose your free gift">' + head('<strong>' + escHtml(G.unlocked) + '</strong>') + giftOptions(st, 'add') + note + '</div>';
    }
    if (st.state === 'free') {
      var img = (st.gift.item.image ? st.gift.item.image + (st.gift.item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : st.gift.product.img);
      return '<div class="ux-gift ux-gift--free" role="status">' +
        '<div class="ux-gift__added"><img src="' + escHtml(img) + '" alt="" width="48" height="48"><div><strong>' + escHtml(G.added(giftName(st.gift))) + '</strong>' +
        '<button type="button" class="ux-gift__link" data-gift-change aria-expanded="' + giftChangeOpen + '">' + (giftChangeOpen ? 'Keep this gift' : 'Change') + '</button></div></div>' +
        (giftChangeOpen ? giftOptions(st, 'swap') : '') + note + '</div>';
    }
    // lost
    var lostMsg = st.need > 0 ? G.lost(fmt(st.need)) : G.lost('a little');
    return '<div class="ux-gift ux-gift--lost" role="status">' + head('<strong>' + escHtml(lostMsg) + '</strong>') +
      '<button type="button" class="ux-gift__btn ux-gift__btn--ghost" data-gift-remove>Remove ' + escHtml(giftName(st.gift)) + '</button></div>';
  }
  var giftLast = null;
  function renderGiftBoxes(cart) {
    var st = giftState(cart);
    giftLast = st;
    if (!st || st.state !== 'free') giftChangeOpen = false;
    document.querySelectorAll('[data-gift-box]').forEach(function(el) { el.innerHTML = st ? giftBoxHtml(st) : ''; });
  }
  function giftAfter() {
    if (document.querySelector('[data-ux-cartpage]')) { location.reload(); return; }
    return fetchCart();
  }
  function giftPost(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function giftRemoveUnit(ref) { return giftPost('/cart/change.js', { line: ref.line, quantity: Math.max(0, ref.item.quantity - 1) }); }
  function giftAdd(vid) { return giftPost('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _free_gift: 'Yes' } }] }); }
  document.addEventListener('change', function(e) {
    var sel = e.target.closest && e.target.closest('[data-gift-variant]');
    if (!sel) return;
    var card = sel.closest('[data-gift-card]'), opt = sel.options[sel.selectedIndex];
    var btn = card.querySelector('[data-gift-add],[data-gift-swap]');
    if (btn) { btn.setAttribute(btn.hasAttribute('data-gift-add') ? 'data-gift-add' : 'data-gift-swap', sel.value); btn.disabled = false; }
    var img = card.querySelector('img'); if (img && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
  });
  document.addEventListener('click', function(e) {
    var t = e.target.closest && e.target.closest('[data-gift-add],[data-gift-swap],[data-gift-change],[data-gift-remove]');
    if (!t || !giftLast) return;
    e.preventDefault();
    if (t.hasAttribute('data-gift-change')) { giftChangeOpen = !giftChangeOpen; if (cartState) renderGiftBoxes(cartState); return; }
    var box = t.closest('.ux-gift'); if (box) box.classList.add('is-busy');
    t.disabled = true;
    var st = giftLast, job;
    if (t.hasAttribute('data-gift-add')) { t.textContent = 'Adding...'; job = giftAdd(parseInt(t.getAttribute('data-gift-add'), 10)); }
    else if (t.hasAttribute('data-gift-swap')) {
      var vid = parseInt(t.getAttribute('data-gift-swap'), 10);
      t.textContent = 'Swapping...';
      if (st.gift && st.gift.item.variant_id === vid) { giftChangeOpen = false; job = Promise.resolve(); }
      else job = (st.gift ? giftRemoveUnit(st.gift) : Promise.resolve()).then(function() { giftChangeOpen = false; return giftAdd(vid); });
    }
    else { t.textContent = 'Removing...'; job = giftRemoveUnit(st.gift); }
    job.then(giftAfter, function() { if (box) box.classList.remove('is-busy'); t.disabled = false; t.textContent = 'Try again'; return fetchCart(); });
  });

  // ===== UPSELL =====
  var upsellAdded = false;
  var upsellRules = [];
  var activeUpsell = null;

  try {
    var rulesEl = document.getElementById('upsellRules');
    if (rulesEl) upsellRules = JSON.parse(rulesEl.textContent);
  } catch(e) {}

  function renderUpsell(cart) {
    var upsellEl = document.getElementById('cartUpsell');
    if (!upsellEl) return;
    if (cart.items.length === 0) { upsellEl.style.display = 'none'; upsellAdded = false; return; }
    // Reset upsellAdded if the upsell product was removed from cart
    if (upsellAdded && activeUpsell) {
      var stillInCart = cart.items.some(function(item) { return item.handle === activeUpsell.upsell_handle; });
      if (!stillInCart) upsellAdded = false;
    }
    if (upsellAdded) { upsellEl.style.display = 'none'; return; }

    var cartHandles = cart.items.map(function(item) { return item.handle; });
    var matched = null;
    // Gift picker 10-10: while the gift box shows (U.S.), never upsell the gift products (cloth at $5 / keychain at
    // full price would conflict with "pick one free").
    var giftOn = !!giftState(cart);
    var skip = function(rule) { return giftOn && !!giftProduct(rule.upsell_handle); };

    // Find first matching rule based on cart contents
    for (var i = 0; i < upsellRules.length; i++) {
      var rule = upsellRules[i];
      if (rule.trigger === '_default' || skip(rule)) continue;
      if (cartHandles.indexOf(rule.trigger) !== -1 && cartHandles.indexOf(rule.upsell_handle) === -1) {
        matched = rule;
        break;
      }
    }

    // Fall back to default if no specific match, and default upsell not already in cart
    if (!matched) {
      for (var j = 0; j < upsellRules.length; j++) {
        if (upsellRules[j].trigger === '_default' && !skip(upsellRules[j]) && cartHandles.indexOf(upsellRules[j].upsell_handle) === -1) {
          matched = upsellRules[j];
          break;
        }
      }
    }

    if (!matched) { upsellEl.style.display = 'none'; return; }

    activeUpsell = matched;
    var bannerEl = document.getElementById('upsellBanner');
    var titleEl = document.getElementById('upsellTitle');
    if (bannerEl) {
      // UX TEST: calm labels, no inline gradients (styled by ux.css)
      bannerEl.style.background = '';
      bannerEl.textContent = matched.banner === 'float' ? 'Made for the water' : 'Complete your kit';
      if (titleEl) titleEl.textContent = matched.product_title || 'Complete your kit';
    }
    document.getElementById('upsellDesc').innerHTML = matched.desc;
    document.getElementById('upsellImg').src = matched.product_img;
    document.getElementById('upsellImg').className = 'ux-upsell-img';
    document.getElementById('upsellImg').alt = matched.product_title;
    var priceHtml = '';
    if (matched.sale_price && matched.original_price) {
      priceHtml = '<span class="cart-upsell-original">' + matched.original_price + '</span>' +
        '<span class="cart-upsell-sale">' + matched.sale_price + '</span>' +
        '<span class="cart-upsell-badge">' + (matched.discount_label || 'SALE') + '</span>';
    } else {
      priceHtml = '<span class="cart-upsell-sale">' + matched.product_price + '</span>';
    }
    document.getElementById('upsellPrice').innerHTML = priceHtml;

    var pickerEl = document.getElementById('upsellVariantPicker');
    var selectEl = document.getElementById('upsellVariantSelect');
    if (matched.has_variants && matched.variants && matched.variants.length > 1) {
      selectEl.innerHTML = '';
      matched.variants.forEach(function(v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        if (v.img) opt.setAttribute('data-img', v.img);
        selectEl.appendChild(opt);
      });
      selectEl.onchange = function() {
        var selectedOpt = this.options[this.selectedIndex];
        var varImg = selectedOpt.getAttribute('data-img');
        if (varImg) {
          document.getElementById('upsellImg').src = varImg;
        }
      };
      pickerEl.style.display = 'block';
    } else {
      pickerEl.style.display = 'none';
    }

    upsellEl.style.display = 'block';
  }

  window._addUpsell = function() {
    if (!activeUpsell || upsellAdded) return;
    var vid;
    if (activeUpsell.has_variants) {
      var selectEl = document.getElementById('upsellVariantSelect');
      vid = selectEl ? parseInt(selectEl.value) : (activeUpsell.variants && activeUpsell.variants[0] ? activeUpsell.variants[0].id : null);
    } else {
      vid = activeUpsell.variant_id;
    }
    if (!vid) return;
    upsellAdded = true;
    showConfetti();
    addToCart(vid, 1);
  };

  // ===== CONFETTI + SPINNING ANCHOR =====
  function showConfetti() {
    var container = document.createElement('div');
    container.className = 'confetti-container';
    var colors = ['#0ea5e9', '#22d3ee', '#ff6b35', '#22c55e', '#f59e0b', '#a855f7', '#ec4899', '#fff'];
    for (var i = 0; i < 40; i++) {
      var piece = document.createElement('div');
      piece.className = 'confetti-piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[Math.floor(Math.random() * colors.length)];
      piece.style.animationDelay = Math.random() * 1.5 + 's';
      piece.style.width = (Math.random() * 8 + 6) + 'px';
      piece.style.height = (Math.random() * 8 + 6) + 'px';
      container.appendChild(piece);
    }
    document.body.appendChild(container);
    var anchor = document.createElement('div');
    anchor.className = 'spinning-anchor';
    anchor.innerHTML = '<svg width="120" height="120" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="12" stroke="#0ea5e9" stroke-width="2"/><circle cx="14" cy="7" r="2" stroke="#0ea5e9" stroke-width="1.5"/><line x1="14" y1="9" x2="14" y2="23" stroke="#0ea5e9" stroke-width="2" stroke-linecap="round"/><path d="M7 17c0 4 3.5 6 7 6s7-2 7-6" stroke="#0ea5e9" stroke-width="2" stroke-linecap="round" fill="none"/><line x1="10" y1="14" x2="18" y2="14" stroke="#0ea5e9" stroke-width="2" stroke-linecap="round"/></svg>';
    document.body.appendChild(anchor);
    setTimeout(function() { container.remove(); anchor.remove(); }, 4500);
  }

  // ===== GLOBAL CART FUNCTIONS =====
  window._cartQty = function(key, qty) {
    changeCartItem(key, qty);
  };

  // ===== QUICK ADD BUTTONS (Shopify variant IDs) =====
  document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = parseInt(this.getAttribute('data-add-to-cart'));
      if (variantId) addToCart(variantId, 1);
    });
  });

  // ===== SWATCH CLICK - SWAP MAIN IMAGE =====
  document.querySelectorAll('.product-swatches .swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function(e) {
      e.stopPropagation();
      var variantImg = this.getAttribute('data-variant-img');
      if (!variantImg) return;
      var swatchContainer = this.closest('.product-swatches');
      swatchContainer.querySelectorAll('.swatch').forEach(function(s) { s.classList.remove('active'); });
      this.classList.add('active');
      var card = this.closest('.product-card');
      var img = card.querySelector('.product-img-inner img');
      if (img) {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.25s ease';
        setTimeout(function() {
          img.src = variantImg;
          img.style.opacity = '1';
        }, 150);
      }
    });
  });

  // ===== SCROLL ANIMATIONS =====
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.product-card, .feature-card').forEach(function(el, i) {
    el.style.transitionDelay = (i % 4) * 0.1 + 's';
    el.style.transition = 'opacity 0.6s ease ' + (i % 4) * 0.1 + 's, transform 0.6s ease ' + (i % 4) * 0.1 + 's';
    observer.observe(el);
  });

  document.querySelectorAll('.feature-card').forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';
  });
  var featureObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.feature-card').forEach(function(el) {
    featureObserver.observe(el);
  });

  // ===== BACK TO TOP =====
  if (backToTop) {
    backToTop.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ===== NEWSLETTER =====
  var nlFormParent = newsletterForm ? newsletterForm.closest('form') : null;
  if (nlFormParent) {
    nlFormParent.addEventListener('submit', function(e) {
      var input = this.querySelector('input[type="email"]');
      var btn = this.querySelector('button');
      var email = input.value.trim();
      if (!email) { e.preventDefault(); return; }
      // Let Shopify handle the form submission natively
      btn.textContent = 'Subscribing...';
      btn.disabled = true;
    });
  }

  // ===== SMOOTH SCROLL FOR NAV LINKS =====
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ===== KEYBOARD: ESC TO CLOSE =====
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCart();
      closeMobile();
      // Close modal
      var modalOverlay = document.querySelector('.modal-overlay.open');
      if (modalOverlay) modalOverlay.classList.remove('open');
    }
  });

  // ===== BEFORE/AFTER COMPARISON SLIDERS =====
  (function() {
    var sliders = document.querySelectorAll('.js-comparison-slider');
    var activeSlider = null;

    sliders.forEach(function(slider) {
      var beforeImg = slider.querySelector('.comparison-img-before');
      var divider = slider.querySelector('.comparison-divider');
      var handle = slider.querySelector('.comparison-handle');

      function setPosition(x) {
        var rect = slider.getBoundingClientRect();
        var pos = Math.max(0, Math.min(x - rect.left, rect.width));
        var pct = (pos / rect.width) * 100;
        beforeImg.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        divider.style.left = pct + '%';
        handle.style.left = pct + '%';
      }

      slider.addEventListener('mousedown', function(e) {
        e.preventDefault();
        activeSlider = { setPosition: setPosition };
        setPosition(e.clientX);
      });

      slider.addEventListener('touchstart', function(e) {
        activeSlider = { setPosition: setPosition };
        setPosition(e.touches[0].clientX);
      }, { passive: true });
    });

    document.addEventListener('mousemove', function(e) {
      if (!activeSlider) return;
      e.preventDefault();
      activeSlider.setPosition(e.clientX);
    });
    document.addEventListener('mouseup', function() { activeSlider = null; });
    document.addEventListener('touchmove', function(e) {
      if (!activeSlider) return;
      activeSlider.setPosition(e.touches[0].clientX);
    }, { passive: true });
    document.addEventListener('touchend', function() { activeSlider = null; });
  })();

  // ===== VIDEO SHUFFLE =====
  (function() {
    var grid = document.querySelector('.yt-vertical-grid');
    if (!grid) return;
    var cards = Array.from(grid.querySelectorAll('.yt-vertical-card'));
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = cards[i];
      cards[i] = cards[j];
      cards[j] = temp;
    }
    cards.forEach(function(card) { grid.appendChild(card); });
  })();

  // ===== PRODUCT FILTER (homepage) =====
  window.filterProducts = function(category, btn) {
    document.querySelectorAll('.filter-btn').forEach(function(b) { b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.product-card').forEach(function(card) {
      if (category === 'all' || (card.dataset.category && card.dataset.category.indexOf(category) !== -1)) {
        card.style.display = '';
        card.style.animation = 'fadeInUp 0.4s ease forwards';
      } else {
        card.style.display = 'none';
      }
    });
  };

  // ===== CHECKOUT BUTTON =====
  document.querySelectorAll('.cart-checkout-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      window.location.href = '/cart';
    });
  });

  // ===== TOUCH SWIPE ON MAIN PRODUCT IMAGE =====
  (function() {
    var mainImg = document.querySelector('.pdp-main-img, .main-image-wrap, .product-page-main-img');
    if (!mainImg) return;
    var startX = 0, threshold = 50;
    mainImg.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    mainImg.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > threshold) {
        if (typeof navImage === 'function') {
          if (dx < 0) { navImage(1); } else { navImage(-1); }
        }
      }
    }, { passive: true });
  })();

  // ===== INIT: FETCH CART ON LOAD =====
  fetchCart();

})();

// Theme toggle removed 2026-06-21 — site is light-mode only.
// Force-clear any old 'dark' preference for returning visitors so they get light too.
(function() {
  document.body.classList.add('light-mode');
  try { localStorage.removeItem('anchorTheme'); } catch (e) {}
})();
function toggleTheme() {} // no-op safety in case other code still calls it

/* ============================================================
   SimGym fix 2026-05-22 — Global toast notification helper.
   Used to confirm "Bundle Added", discount applied, etc., so
   shoppers always see explicit feedback after a cart action.
   ============================================================ */
(function () {
  function ensureContainer() {
    var c = document.getElementById('anchor-toast-stack');
    if (c) return c;
    c = document.createElement('div');
    c.id = 'anchor-toast-stack';
    c.setAttribute('aria-live', 'polite');
    c.style.cssText = 'position:fixed;top:80px;right:16px;z-index:9999;display:flex;flex-direction:column;gap:10px;pointer-events:none;max-width:380px;';
    document.body.appendChild(c);
    return c;
  }
  function makeToast(opts) {
    opts = opts || {};
    var title = opts.title || '';
    var body = opts.body || '';
    var duration = typeof opts.duration === 'number' ? opts.duration : 4000;
    var t = document.createElement('div');
    t.style.cssText = [
      'pointer-events:auto',
      'background:linear-gradient(135deg, #22c55e, #16a34a)',
      'color:#fff',
      'padding:14px 18px',
      'border-radius:12px',
      'box-shadow:0 10px 30px rgba(0,0,0,0.3)',
      'font-family:inherit',
      'min-width:280px',
      'opacity:0',
      'transform:translateX(20px)',
      'transition:opacity 0.25s ease, transform 0.25s ease',
      'cursor:pointer'
    ].join(';');
    t.innerHTML =
      '<div style="font-weight:700;font-size:0.95rem;margin-bottom:' + (body ? '4px' : '0') + ';">' +
        (title.replace(/[<>]/g, '')) +
      '</div>' +
      (body ? '<div style="font-size:0.82rem;opacity:0.95;line-height:1.4;">' + body.replace(/[<>]/g, '') + '</div>' : '');
    var stack = ensureContainer();
    stack.appendChild(t);
    requestAnimationFrame(function () {
      t.style.opacity = '1';
      t.style.transform = 'translateX(0)';
    });
    var removed = false;
    function remove() {
      if (removed) return;
      removed = true;
      t.style.opacity = '0';
      t.style.transform = 'translateX(20px)';
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 280);
    }
    t.addEventListener('click', remove);
    setTimeout(remove, duration);
    return t;
  }
  window._anchorToast = makeToast;
})();
